import { ArrowsInIcon as PhosphorArrowsInIcon } from "@phosphor-icons/react/dist/ssr/ArrowsIn";

import { createAppIcon } from "@/components/createAppIcon";

export const CollapseIcon = /* @__PURE__ */ createAppIcon(PhosphorArrowsInIcon);
